import React from "react";
import LoadingScreen from "../LoadingScreen";

export default function PageLoading() {
  return <LoadingScreen className="app-loading" />;
}
